import type { FoodEntry } from "@/types";

/**
 * Sums a day's logged nutrients. `nutrients` keys are expected to align with
 * the nutrition engine's micronutrient keys plus "calories", "protein",
 * "carbs", "fat", "fiber", "caffeine", "alcoholStdDrinks".
 */
export function sumNutrients(entries: FoodEntry[]): Record<string, number> {
  const totals: Record<string, number> = {};
  for (const entry of entries) {
    for (const [key, value] of Object.entries(entry.nutrients)) {
      totals[key] = (totals[key] ?? 0) + value;
    }
  }
  return totals;
}
